import countryList from "../containers/CountrySelect/CountryList";
import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

function initColumns(multiplicity, includeActions = false) {
    let columns = [];
    for (let i = 0; i < multiplicity; i++) {
        let prefix = 'p' + i + '.';
        columns.push({id: prefix + 'lastName', numeric: false, disablePadding: false, label: 'playersList.lastName', sortable: true});
        columns.push({id: prefix + 'firstName', numeric: false, disablePadding: false, label: 'playersList.firstName', sortable: true});
        columns.push({id: prefix + 'gender', numeric: false, disablePadding: false, label: 'playersList.gender', sortable: true});
        columns.push({id: prefix + 'country', numeric: false, disablePadding: false, label: 'playersList.country', sortable: true});
    }
    if (includeActions) {
        columns.push({id: 'actions', numeric: false, disablePadding: true, label: '', sortable: false});
    }
    return columns;
}


function desc(a, b, orderBy) {
    if (!orderBy) {
        return 0;
    }
    const ss = orderBy.split('.');
    if (ss.length !== 2) {
        return 0;
    }
    orderBy = ss[1];
    let idx = 0;
    if (ss[0] === 'p1') {
        idx = 1;
    }
    const p1 = a.players[idx];
    const p2 = b.players[idx];

    const varType = typeof p2[orderBy];
    if ('string' === varType) {
        return p2[orderBy].localeCompare(p1[orderBy]);
    } else {
        if (p2[orderBy] < p1[orderBy]) {
            return -1;
        } else if (p2[orderBy] > p1[orderBy]) {
            return 1;
        } else {
            return 0;
        }

    }

}

function getSort(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function sortData(array, cmp) {
    const tmp = array.map((el, index) => [el, index]);
    tmp.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return tmp.map(el => el[0]);
}

const countryMapReducer = (array) => {
    const cm = array.reduce((obj, item) => {
        obj[item.code] = item;
        return obj;
    }, {});
    return cm;
};
const countryMap = countryMapReducer(countryList);

function DownloadIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/>
        </SvgIcon>
    )
}

export {desc, getSort, sortData, countryMap, initColumns, DownloadIcon};